import { SIGN_IN_REQUEST, SIGN_IN_SUCCESS, SIGN_IN_FAILURE, SIGN_OUT } from '../actions/signIn';

const initialState = {
  loading: false,
  error: null,
  data: null,
};

export default function signInReducer(state = initialState, action) {
  switch (action.type) {
    case SIGN_IN_REQUEST:
      return { ...state, loading: true, error: null };
    case SIGN_IN_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case SIGN_IN_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case SIGN_OUT:
        return { ...state, loading: false, error: null, data: null };
    default:
      return state;
  }
}